import React from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import Components from "../../components/index"
import { StyledCard } from "./partials"

const CardV2 = ({ blok }) => (
  <SbEditable content={blok}>
    <StyledCard
      padding={blok.padding}
      bgImage={blok.bg_image ? blok.bg_image.filename : ""}
    >
      {blok.content &&
        blok.content.map((c) =>
          React.createElement(Components(c.component), {
            key: c._uid,
            blok: c,
          })
        )}
    </StyledCard>
  </SbEditable>
)

export default CardV2
